"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _typeof2 = _interopRequireDefault(require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/typeof.js"));
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.weak-map");
var _layout = _interopRequireDefault(require("@/layout"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != (0, _typeof2.default)(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); } /** When your routing table is too long, you can split it into small modules **/
var schoolRouter = {
  path: '/webSet',
  component: _layout.default,
  meta: {
    title: '网站设置',
    icon: 'nested'
  },
  children: [
  // 新闻管理
  {
    path: 'webSet-news',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/backstage/webSet/newsSet/index.vue'));
      });
    },
    // Parent router-view
    name: 'webSetNews',
    meta: {
      title: '新闻管理',
      icon: 'dashboard'
    }
  }, {
    path: 'webSet-news-add',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/backstage/webSet/newsSet/newsAdd.vue'));
      });
    },
    // Parent router-view
    name: 'webSetNewsAdd',
    hidden: true,
    meta: {
      title: '新增新闻',
      icon: 'dashboard'
    }
  }, {
    path: 'webSet-news-edit',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/backstage/webSet/newsSet/newsEdit.vue'));
      });
    },
    // Parent router-view
    name: 'webSetNewsEdit',
    hidden: true,
    meta: {
      title: '编辑新闻',
      icon: 'dashboard'
    }
  },
  // 新闻分类管理
  {
    path: 'webSet-type',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/backstage/webSet/newsTypeSet/index.vue'));
      });
    },
    // Parent router-view
    name: 'webSetType',
    meta: {
      title: '新闻分类管理',
      icon: 'dashboard'
    }
  }, {
    path: 'webSet-type-add',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/backstage/webSet/newsTypeSet/newsTypeAdd.vue'));
      });
    },
    // Parent router-view
    name: 'webSetTypeAdd',
    hidden: true,
    meta: {
      title: '新增新闻分类',
      icon: 'dashboard'
    }
  }, {
    path: 'webSet-type-edit',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/backstage/webSet/newsTypeSet/newsTypeEdit.vue'));
      });
    },
    // Parent router-view
    name: 'webSetTypeEdit',
    hidden: true,
    meta: {
      title: '编辑新闻分类',
      icon: 'dashboard'
    }
  },
  // 轮播图管理
  {
    path: 'webSet-swiper',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/backstage/webSet/swiperSet/index.vue'));
      });
    },
    // Parent router-view
    name: 'webSetSwiper',
    meta: {
      title: '轮播图管理',
      icon: 'dashboard'
    }
  }, {
    path: 'webSet-swiper-add',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/backstage/webSet/swiperSet/swiperAdd.vue'));
      });
    },
    // Parent router-view
    name: 'webSetSwiperAdd',
    hidden: true,
    meta: {
      title: '新增轮播图',
      icon: 'dashboard'
    }
  }, {
    path: 'webSet-swiper-edit',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/backstage/webSet/swiperSet/swiperEdit.vue'));
      });
    },
    // Parent router-view
    name: 'webSetSwiperEdit',
    hidden: true,
    meta: {
      title: '编辑轮播图',
      icon: 'dashboard'
    }
  },
  // 友情链接管理
  {
    path: 'webSet-links',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/backstage/webSet/linksSet/index.vue'));
      });
    },
    // Parent router-view
    name: 'webSetLinks',
    meta: {
      title: '友情链接管理',
      icon: 'dashboard'
    }
  }, {
    path: 'webSet-links-add',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/backstage/webSet/linksSet/linksAdd.vue'));
      });
    },
    name: 'webSetLinksAdd',
    hidden: true,
    meta: {
      title: '新增友情链接',
      icon: 'dashboard'
    }
  }, {
    path: 'webSet-links-edit',
    component: function component() {
      return Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/views/backstage/webSet/linksSet/linksEdit.vue'));
      });
    },
    name: 'webSetLinksEdit',
    hidden: true,
    meta: {
      title: '编辑友情链接',
      icon: 'dashboard'
    }
  }]
};
var _default = exports.default = schoolRouter;